import VideoView from './video-view.vue';
export default VideoView;
